<template>
    <div>
        <div v-if="loading" class="card-pricing card-body">
            <div class="card-icon icon-warning">
                <v-progress-circular style="margin-top: 3px;"
                                     :size="60"
                                     :width="5"
                                     color="primary"
                                     indeterminate
                ></v-progress-circular>
            </div>
            <h3 class="card-title" style="height: 24px;"></h3>
            <ul>
                <li style="height: 46px;"></li>
                <li style="height: 46px;"></li>
                <li style="height: 46px;"></li>
                <li style="height: 46px;"></li>
            </ul>
        </div>
        <div v-else class="card-pricing card-body">
            <div class="card-icon icon-warning">
                <FileIcon :mimetype="file.type" size="60"></FileIcon>
            </div>
            <h3 class="card-title" style="word-break: break-word;">{{file.name}}</h3>
            <ul>
                <li><label style="text-align: left; font-weight: bold;">{{$t('File Type')}}: </label>{{file.type}}</li>
                <li v-if="file.size"><label style="text-align: left; font-weight: bold;">{{$t('Size')}}: </label>{{$prettyBytes(file.size)}}</li>
                <li><label style="text-align: left; font-weight: bold;">{{$t('Creation Date')}}: </label>{{$moment(file.date).format('DD-MM-YYYY HH:mm')}}</li>
                <li><label style="text-align: left; font-weight: bold;">{{$t('Creator')}}: </label>{{file.creator}}</li>
            </ul>
        </div>
        <div class="card-pricing card-body">
            <shared-files-box v-if="file.canGiveAccess" :fileHash="hash" :token="token" :givePermissions="file.givePermissions" :isFileOwner="file.isFileOwner"></shared-files-box>
        </div>
    </div>
</template>

<script>

    import { VProgressCircular } from 'vuetify/lib';
    import FilesRepository from '../repositories/FilesRepository';
    import FileIcon from "./FileIcon";
    import SharedFilesBox from '@/components/SharedFilesCard/ShareFilesBox';

    export default {
        name: 'FileInfo',
        components: {
            FileIcon,
            SharedFilesBox,
            VProgressCircular
        },
        props: {
            hash: String,
            token: String,
            fileData: Object
        },
        data: () => ({
            loading: true,
            file: {
                name: "",
                type: "",
                size: 0,
                creator: "",
                date: "",
                canGiveAccess:false,
                givePermissions:[],
                isFileOwner: false
            },
        }),
        created () {
            this.getFileInfo();
        },
        watch: {
            fileData: function () {
                this.getFileInfo();
            },
        },
        methods: {
            getFileInfo() {

                if (this.fileData) {
                    this.file.name = this.fileData.name;
                    this.file.type = this.fileData.type;
                    this.file.size = this.fileData.size;
                    this.file.creator = this.fileData.creator.name || this.fileData.creator.email;
                    this.file.date = this.fileData.creationDate;
                    if(this.fileData.user_permissions) {

                        var POSITION_DOWNLOAD = 4;
                        var POSITION_VIEW = 5;
                        var POSITION_OWNER = 7;

                        if(this.fileData.user_permissions.permissions[POSITION_OWNER] == 1 ){
                            this.file.isFileOwner = true;
                        }

                        if(this.fileData.user_permissions.givePermissions[POSITION_VIEW] == 1 ){
                            this.file.givePermissions.push('View');
                        }

                        if(this.fileData.user_permissions.givePermissions[POSITION_DOWNLOAD] == 1 ){
                            this.file.givePermissions.push('Download');
                        }

                        this.file.canGiveAccess = (this.fileData.user_permissions.permissions[3] == 1 && (parseInt(this.fileData.user_permissions.givePermissions.join('').toString(), 2) != 0));
                    }
                    this.loading = false;
                } else if (this.hash) {
                    FilesRepository.getFileInfo(this.hash, this.token)
                        .then((response)=>{

                            if(typeof response.data !== "undefined" && typeof response.data.file !== "undefined"){
                                this.file.name = response.data.file.name;
                                this.file.type = response.data.file.type;
                                this.file.size = response.data.file.size;
                                this.file.creator = response.data.file.creator.name || response.data.file.creator.email;
                                this.file.date = response.data.file.creationDate;
                                this.loading = false;
                            }

                        }).catch((error) => {
                        });
                }
            }


        }
    }
</script>

<style lang="scss" scoped>
    .card-pricing ul {
        list-style: none;
        padding: 0;
        max-width: 280px;
        margin: 10px auto;
    }
    .card-pricing ul li {
        color: black;
        text-align: center;
        padding: 12px 0;
        border-bottom: 1px solid hsla(0,0%,53.3%,.3);
    }
    .card-pricing ul {
        border-top: 1px solid hsla(0,0%,53.3%,.3);
    }
    .card-pricing .card-title {
        margin-top: 30px;
    }
    .card-title {
        margin-bottom: .75rem;
    }
</style>